//constants
import { CANONICAL_HOMEPAGE_URL as DOMAIN_NAME } from 'shared/constants/pages';

export const getPlpJSONLD = (products: { products: Listing.IProduct[] }) => {
  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    itemListElement: [
      products.map((product: Record<string, string>, index: number) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: product.title + ' ' + product.subTitle,
          url: DOMAIN_NAME + (product.actionUrl || product.action_url),
        };
      }),
    ],
  });
};
